import { render, staticRenderFns } from "./PopupAIImageRiskRecommendation.vue?vue&type=template&id=cfd89222&scoped=true"
import script from "./PopupAIImageRiskRecommendation.vue?vue&type=script&lang=js"
export * from "./PopupAIImageRiskRecommendation.vue?vue&type=script&lang=js"
import style0 from "./PopupAIImageRiskRecommendation.vue?vue&type=style&index=0&id=cfd89222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd89222",
  null
  
)

export default component.exports